<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for -->
  <div class="mega-menu">
    <div class="mega-menu-wrapper">
      <div class="brands-menu-left">
        <ul class="tabs tabs-brand">
          <li :class="{ active: activeTab === 0 }">
            <a href="" title="Brand Name" @click.prevent="activeTab = 0">Brand Name</a>
          </li>
          <li :class="{ active: activeTab === 1 }">
            <a href="" title="Brand Origins" @click.prevent="activeTab = 1">Brand Origins</a>
          </li>
        </ul>
        <div class="search">
          <input
            v-model="keyword"
            type="text"
            name="search"
            autocomplete="off"
            placeholder="Search Brand..."
            class="input-search"
            @keyup="searchQuery"
          />
          <span class="icon-search"></span>
        </div>
        <template v-if="$SO.size(dynamicDataBrands)">
          <div class="search-by-alpha">
            <a
              v-for="(value, key) in dynamicDataBrands"
              :key="key"
              href="#brand-letter-A"
              class="brand-tag"
              :class="[{ active: selectedLetter === key }, { disabled: !value.length }]"
              @click.prevent="toLetter(key)"
              >{{ key }}</a
            >
            <router-link to="/brands" class="brand-show-all"
              >See all >
              <!-- <img src="~/assets/img/arrow_carrot-right.svg" alt="SOCO"> -->
            </router-link>
          </div>
          <div id="brand-value" class="brand-value">
            <div class="brand-val-list">
              <template v-if="activeTab === 0">
                <template v-for="(value, key) in dynamicDataBrands" v-if="value.length">
                  <h4 v-if="value" :id="'brand-letter-' + key" :key="'brand-letter-' + key" class="">
                    {{ key }}
                  </h4>
                  <ul v-if="value" :key="'brand-letter--' + key">
                    <li v-for="brand in value" :key="brand._id">
                      <router-link
                        :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`"
                        @click.native="selectBrand"
                        >{{ brand.name }}</router-link
                      >
                    </li>
                  </ul>
                </template>
                <!-- <template v-else>
                            <ul>
                                <li>
                                    <span>No Brands</span>
                                </li>
                            </ul>
                          </template> -->
              </template>
              <template v-else>
                <template v-for="(value, key) in dynamicDataBrands" v-if="value.length">
                  <h4 v-if="value" :id="'brand-letter-' + key" :key="'brand-letter-' + key" class="">
                    {{ key }}
                  </h4>
                  <ul v-if="value" :key="'brand-letter--' + key">
                    <li v-for="brand in value" :key="brand._id">
                      <router-link
                        :to="`/brand/${brand.country_tag_id}-${$options.filters.slug(brand.country)}`"
                        @click.native="selectBrand"
                      >
                        <img v-if="brand.flag" :src="brand.flag" :alt="brand.country" class="img_country" />
                        {{ brand.country }}
                      </router-link>
                    </li>
                  </ul>
                </template>
                <!-- <template v-else>
                            <h4 class="" :id="'brand-letter-'+ key" :key="'brand-letter-'+ key">{{key}}</h4>
                            <ul>
                                <li>
                                    <span>No Brands</span>
                                </li>
                            </ul>
                          </template> -->
              </template>
            </div>
          </div>
        </template>
        <div v-else class="gfmp-brand-value">
          <div style="margin-top: 15px"></div>
          <GFMP
            v-for="i in 2"
            :key="`brand-value-${i}`"
            :styles="{
              minHeight: '136px',
              width: '100%',
              marginBottom: '14px',
            }"
          />
        </div>
      </div>
      <div class="brands-menu-right">
        <div class="info-bar">
          <h4 class="info-bar__name">Featured Brands</h4>
        </div>
        <div v-if="featuredBrands.length" class="brand-logo">
          <template v-for="brand in featuredBrands">
            <router-link
              v-if="brand"
              :key="brand._id"
              :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`"
              class="brand_logo_item"
            >
              <template v-if="brand.logo">
                <img :src="brand.logo" :alt="brand.name" onerror="this.src='/assets/img/default_img_brand.svg'" />
              </template>
              <template v-else>
                <img src="/assets/img/default_img_brand.svg" alt="SOCO" />
              </template>
            </router-link>
          </template>
        </div>
        <div v-else-if="reviewedBrands.length" class="brand-logo">
          <template v-for="brand in reviewedBrands">
            <router-link
              v-if="brand"
              :key="brand._id"
              :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`"
              class="brand_logo_item"
            >
              <template v-if="brand.logo">
                <img :src="brand.logo" :alt="brand.name" onerror="this.src='/assets/img/default_img_brand.svg'" />
              </template>
              <template v-else>
                <img src="/assets/img/default_img_brand.svg" alt="SOCO" />
              </template>
            </router-link>
          </template>
        </div>
        <div v-else>
          <GFMP
            v-for="i in 2"
            :key="`brand-logo-${i}`"
            :styles="{ minHeight: '76px', width: '100%', marginBottom: '14px' }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navbar-brands',
  data() {
    return {
      filterBrands: [],
      keyword: '',
      selectedLetter: '',
      isLoadingFinishMostReviewBrand: false,
      activeTab: 0,
    };
  },
  computed: {
    featuredBrands() {
      return this.$store.state.featuredBrands;
    },
    reviewedBrands() {
      return this.$store.state.reviewedBrands;
    },
    allBrands: {
      get() {
        return this.$store.state.brands;
      },
      set(data) {
        this.$store.commit('setDataBrands', data);
      },
    },
    allOriginBrands: {
      get() {
        return this.$store.state.brands_origin;
      },
      set(data) {
        this.$store.commit('setDataBrandsOrigin', data);
      },
    },
    dynamicDataBrands() {
      if (this.activeTab === 0) {
        return this.$SO.size(this.filterBrands) ? this.filterBrands : this.allBrands;
      } else {
        return this.$SO.size(this.filterBrands) ? this.filterBrands : this.allOriginBrands;
      }
    },
  },
  watch: {
    activeTab(newVal, oldVal) {
      this.keyword = '';
      this.filterBrands = [];
      if (newVal == 1 && !this.$store.state.brands_origin) {
        this.$store.dispatch('getBrandsOrigin');
      }
    },
  },
  created() {
    if (!this.$SO.size(this.dynamicDataBrands)) {
      this.$store.dispatch('getBrands');
    }
    if (!this.$store.state.featuredBrands.length || !this.$store.state.reviewedBrands.length) {
      this.getMostReviewsBrands();
    }
  },
  methods: {
    toLetter(letter) {
      this.selectedLetter = letter;
      const topPos = document.getElementById('brand-letter-' + letter).offsetTop;
      const containerOffset = document.getElementById('brand-value').offsetTop;
      document.getElementById('brand-value').scrollTop = topPos - containerOffset;
    },
    getMostReviewsBrands() {
      this.isLoadingFinishMostReviewBrand = false;
      let loadedBrandsHash = [];
      let featuredBrands = [];
      let defaultBrands = [];
      this.$MS_SOCO_PUBLIC_API_URL
        .get('/brands', {
          params: {
            fields: 'my_soco_sql_id name logo featured_position',
            filter: {
              is_featured: true,
            },
            sort: 'featured_position',
            limit: 10,
          },
        })
        .then((res) => {
          if (res.status === 200 && res.data.data) {
            featuredBrands = res.data.data;
            this.$store.commit('setFeaturedBrands', res.data.data);
            loadedBrandsHash = loadedBrandsHash.concat(featuredBrands.map((it) => it._id));
          }
        })
        .then(() => {
          if (loadedBrandsHash.length < 10) {
            return this.$MS_SOCO_PUBLIC_API_URL
              .get('/brands', {
                params: {
                  fields: 'my_soco_sql_id name logo',
                  section: 'most-reviewed-brand',
                  filter: {
                    _id: { $nin: loadedBrandsHash },
                  },
                  sort: '-total_reviews',
                  limit: 10 - loadedBrandsHash.length,
                },
              })
              .then((response) => {
                if (response.status === 200 && response.data.data) {
                  defaultBrands = response.data.data;
                }
              });
          } else {
            return;
          }
        })
        .then(() => {
          const brands = [];
          const maxLength = 10;
          let position = 0;
          let featuredPosition = 0;
          let defaultPosition = 0;

          while (position < maxLength) {
            if (featuredBrands[featuredPosition] && featuredBrands[featuredPosition].featured_position == position) {
              brands.push({
                ...featuredBrands[featuredPosition],
                featured_position: position,
              });
              featuredPosition++;
            } else if (defaultBrands[defaultPosition]) {
              brands.push({
                ...defaultBrands[defaultPosition],
                featured_position: position,
              });
              defaultPosition++;
            }
            position++;
          }

          this.$store.commit('setReviewedBrands', brands);
          this.isLoadingFinishMostReviewBrand = true;
        })
        .catch((err) => {
          this.isLoadingFinishMostReviewBrand = true;
        });
    },
    searchQuery(e) {
      if (this.keyword) {
        const searchResult = {};
        if (this.activeTab === 0) {
          Object.keys(this.allBrands).map((alphabet) => {
            this.allBrands[alphabet].forEach((brand) => {
              if (brand.name.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0) {
                if (!searchResult[brand.name[0].toUpperCase()]) {
                  searchResult[brand.name[0].toUpperCase()] = [];
                }
                searchResult[brand.name[0].toUpperCase()].push(brand);
              }
            });
          });
        } else {
          Object.keys(this.allOriginBrands).map((alphabet) => {
            this.allOriginBrands[alphabet].forEach((brand) => {
              if (brand.country.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0) {
                if (!searchResult[brand.country[0].toUpperCase()]) {
                  searchResult[brand.country[0].toUpperCase()] = [];
                }
                searchResult[brand.country[0].toUpperCase()].push(brand);
              }
            });
          });
        }
        this.filterBrands = searchResult;
      } else {
        this.filterBrands = '';
      }
    },
    selectBrand() {
      if (!this.$store.state.screen.isDesktop) {
        this.$store.commit('updatePrimaryMenuMobile', '');
      }
    },
  },
};
</script>

<style lang="scss">
@import 'brands';
</style>
